import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { fundraisingService } from '../../services/fundraisingService';

export const useSubmitFundraisingApplication = (applicationId, fundraisingId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload =>
      fundraisingService.submitApplication(applicationId, payload).then(response => {
        const { status, data } = response;
        if (status === 200) {
          queryClient.invalidateQueries({
            queryKey: [QUERY_KEYS.fundraising.application_by_fundraising_id, fundraisingId],
          });
          return data;
        }
      }),
  });
};
